// this page is for when it is imported as an npm module
import PageTitle from './src/components/fragments/PageTitle';
import Header from './src/components/fragments/Header';
import Footer from './src/components/fragments/Footer';
import Banner from './src/components/fragments/Banner';
import ErrorBanner from './src/components/fragments/ErrorBanner';
import TextBox from './src/components/fragments/TextBox';
import Checkbox from './src/components/fragments/Checkbox';
import DataTable from './src/components/fragments/DataTable';
import Statistic from './src/components/fragments/Statistic';
import TextHeading1 from './src/components/fragments/TextHeading1';
import TextHeading2 from './src/components/fragments/TextHeading2';
import TextHeading3 from './src/components/fragments/TextHeading3';
import Button from './src/components/fragments/Button';
import Grid from './src/components/fragments/Grid';
import YesNo from './src/components/fragments/YesNo';
import CheckboxGroup from './src/components/fragments/CheckboxGroup';

export default {
  fragments: {
    CheckboxGroup,
    YesNo,
    Grid,
    TextHeading1,
    TextHeading2,
    TextHeading3,
    PageTitle,
    Header,
    Footer,
    Banner,
    ErrorBanner,
    TextBox,
    Checkbox,
    DataTable,
    Statistic,
    Button,
  },
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@vigilantapps/vapps-ui-vuejs-elements/index.js
// module id = Nco5
// module chunks = 0